import { axios } from "~/plugins/request"
export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  initOrderList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/onlineOrder/findFailOrderList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getOrderDetailById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/onlineOrder/findFailOrderById', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  exportOrder({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/onlineOrder/exportFailOrder',
        data: params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  handleFailOrder({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/onlineOrder/handleFailOrderById', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
}